<template>
  <div class="block">
    <el-timeline class="scrollable" v-loading="loading">
      <comment-box-item
        v-for="(c, index) in comments"
        :key="index"
        :content="c[keyContent]"
        :img="c.Image"
        :date="c.CreatedAt"
        v-bind="c"
      ></comment-box-item>
    </el-timeline>
  </div>
</template>

<script>
import CommentBox from "./CommentBox.vue";

export default {
  name: "CommentList",
  components: {
    "comment-box-item": CommentBox
  },
  props: {
    /**
     * Example [{cotent: "Contenido del comentario", img: "http:/example.com/profile.png"}]
     */
    loading: {
      type: Boolean,
      default: false
    },
    comments: {
      type: Array,
      default: () => [],
      require: true
    },
    keyContent: {
      type: String,
      default: "content"
    }
  },
  data() {
    return {
      test: [
        {
          content: "Hola 1"
        },
        {
          content: "Hola 2"
        },
        {
          content: "Hola 1"
        },
        {
          content: "Hola 2"
        },
        {
          content: "Hola 1"
        },
        {
          content: "Hola 2"
        },
        {
          content: "Hola 1"
        },
        {
          content: "Hola 2"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.block {
  background-color: $background-color;
  padding-top: 10px;

  .el-timeline {
    height: 750px;
  }
}
</style>
